import {
    ManualJournalRecurringPeriod,
    MonthRecurrenceType,
} from "@common/schemas/domains/accounting/manualJournalRecurringRule";
import { generateDayOptions } from "@components/accounting/journalEntryDrawer/helpers";

export const RECURRING_PERIOD = [
    {
        value: ManualJournalRecurringPeriod.DAILY,
        label: "Daily",
        labelWithNumber: "Day",
    },
    {
        value: ManualJournalRecurringPeriod.WEEKLY,
        label: "Weekly",
        labelWithNumber: "Week",
    },
    {
        value: ManualJournalRecurringPeriod.MONTHLY,
        label: "Monthly",
        labelWithNumber: "Month",
    },
    {
        value: ManualJournalRecurringPeriod.YEARLY,
        label: "Yearly",
        labelWithNumber: "Year",
    },
];

export const weekDayOptions = [
    { label: "Monday", value: 1 },
    { label: "Tuesday", value: 2 },
    { label: "Wednesday", value: 3 },
    { label: "Thursday", value: 4 },
    { label: "Friday", value: 5 },
    { label: "Saturday", value: 6 },
    { label: "Sunday", value: 0 },
];

export const monthOptions = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
];

export const monthRecurrenceTypeOptions = [
    { label: "Day", value: MonthRecurrenceType.DAY },
    { label: "First", value: MonthRecurrenceType.FIRST_WEEKDAY_OCCURRENCE },
    { label: "Second", value: MonthRecurrenceType.SECOND_WEEKDAY_OCCURRENCE },
    { label: "Third", value: MonthRecurrenceType.THIRD_WEEKDAY_OCCURRENCE },
    { label: "Fourth", value: MonthRecurrenceType.FOURTH_WEEKDAY_OCCURRENCE },
    { label: "Last", value: MonthRecurrenceType.LAST_WEEKDAY_OCCURRENCE },
];

export const dayOptions = (() => {
    const commonOptions = generateDayOptions(11);
    commonOptions[0].label = "First";
    commonOptions[commonOptions.length - 1].label = "Last";

    return commonOptions;
})();
